module.exports = __webpack_public_path__ + "static/media/employee-synchronization_SK.8e320381.md";